import axios from 'axios';

const http = function (args) {
  return {
    getBaseUrl() {
      const host = window.location.host;

      // For staging environment
      if (host.includes('vintanalabs.com')) {
        return 'https://staging-invoice-gateway.vintanalabs.com';
      }

      // For local IP-based development
      if (host === '127.0.0.1' || host === 'localhost') {
        return `${window.location.protocol}//${host}`;
      }

      // For local domain-based development
      return `${window.location.protocol}//invoice-gateway.test`;
    },

    axios(axios_options) {
      let axios_instance = axios.create({
        baseURL: this.getBaseUrl(),
        timeout: 1000,
        ...axios_options,
      });

      this.configureInterceptor(axios_instance, this.successHandler, this.errorHandler);
      return axios_instance;
    },

    configureInterceptor(axios_instance, successHandler, errorHandler) {
      axios_instance.interceptors.response.use(successHandler, errorHandler);
    },

    successHandler: (response) => response,

    errorHandler: (error) => {
      return Promise.reject(error);
    },
  };
};

export default http;
